import Vue from 'vue/dist/vue';
import { store } from 'js/modules/vue/store';
import { formatMoney, searchParentElements, formatCityName } from 'helpers/utils';
import { order } from 'js/modules/vue/modules/order-builder';
import { debounce } from 'helpers/api';
import swal from 'sweetalert';

document.addEventListener('DOMContentLoaded', async function () {
    const orderBuilder = document.querySelector('#order-builder-search');
    if (orderBuilder) {
        new Vue({
            el: '#order-builder-search',
            data: {
                selectedIndex: -1,
                currentEditId: null,
                previousNote: null,
                NoSelectedPart: false,
                search: '',
                defaultWarehouse: null,
                isPopupVisible: false,
                selectedPartForPopup: null,
                isCollapsed: true,
                alternativePart: null,
            },
            order,
            mounted: function () {
                store.dispatch('InitOrder');
                store.dispatch('UpdateItemsCount');
            },
            filters: {
                formatMoney: function (value) {
                    return formatMoney(value);
                },
                formatCityName: function (city) {
                    return formatCityName(city);
                },
            },
            watch: {
                search: debounce(function (newvalue) {
                    if (this.search != order.state.Search.Term && newvalue && newvalue.trim()) {
                        store.dispatch('Autocomplete', { Term: newvalue });
                    }
                    if (this.search == null || this.search === '') {
                        order.state.Search.Part = {};
                    }
                }, 300),

                orderTotal: function () {
                    store.dispatch('UpdateItemsCount');
                },
            },
            computed: {
                checked: {
                    get: function () {
                        return order.state.Search.Type !== 'OB';
                    },
                    set: function (value) {
                        store.dispatch('Autocomplete', {
                            Term: order.state.Search.Term,
                            Type: value ? 'CR' : 'OB',
                            Selected: false,
                            DropDown: true,
                            force: true,
                        });
                    },
                },
                getState: {
                    get: function () {
                        return order.state;
                    },
                },
                // search: {
                //     get: function () {
                //         return order.state.Search.Term
                //     },
                //     set: function (value) {
                //         store.dispatch('Autocomplete', { Term: value })
                //     }
                // },
                part: {
                    get: function () {
                        return order.state.Search.Part;
                    },
                    set: function (value) {
                        store.commit('UpdateSearch', { Part: value });
                    },
                },
                qty: {
                    get: function () {
                        return store.state.Search.Part.Quantity;
                    },
                    set: function (value) {
                        if (!this.isSelected) {
                            const item = store.state.Search.Part;
                            item.Quantity = value;
                            store.commit('UpdateSearch', { Part: item });
                        }
                    },
                },
                orderTotal: function () {
                    //console.log("Total mp", order.state.Order.Total);
                    return formatMoney(order.state.Order.Total);
                },
                maxCartItems: function () {
                    return order.state.MaxCartItems;
                },
                activeCartItemCount: function () {
                    return order.state.ActiveItemCount;
                },
                inActiveCartItemCount: function () {
                    return order.state.InActiveItemCount;
                },
                totalItemCount: function () {
                    console.log(this.activeCartItemCount, this.list.length);
                    return this.activeCartItemCount + this.list.length;
                },
                showModal: function () {
                    return order.state.Modal.Show;
                },
                showCrossRef: function () {
                    return this.checked ? store.state.Search.Selected : false;
                },
                isSelected: function () {
                    return order.state.Search.Selected;
                },
                searchResults: function () {
                    return order.state.Search.Results;
                },
                crossrefParts: function () {
                    return order.state.CrossReference.Parts;
                },
                // hasInventory: function (part) {
                //     if (part.Product.ManufacturerCode == "MER") {
                //         for (var i = 0; i < part.Product.AllStockInfo.length; i++) {
                //             var current = part.Product.AllStockInfo
                //             switch ()
                //         }
                //         }
                //         return false;
                //     },
                showDropDown: {
                    get: function () {
                        return order.state.Search.DropDown && order.state.Search.Results.length;
                    },
                    set: function (value) {
                        store.commit('UpdateSearch', { DropDown: value });
                    },
                },
                list: function () {
                    return order.state.Order.List;
                },
                isAlternateWarehouseDisabled() {
                    return order.state.isAlternateWarehouseDisabled;
                },
                disableSmartShip() {
                    return order.state.disableSmartShip;
                },
                alternativeParts() {
                    return order.state.alternativeParts;
                },
                isAlternativePartAvailable() {
                    if (this.alternativePart) {
                        const totalAvailableCount =
                            this.alternativePart.Product.AllStockInfo.reduce(
                                (acc, item) => acc + item.AVAILABLE_COUNT,
                                0,
                            );

                        this.alternativePart.Product.AllStockInfo.forEach((stockInfo) => {
                            Vue.set(stockInfo, 'isAltQuantityValid', true); // Initialize the validation state
                        });
                        return totalAvailableCount > 0;
                    }
                    return false;
                },
            },
            methods: {
                appClick: function (event) {
                    if (
                        !(
                            searchParentElements(
                                event.target,
                                { type: 'class', value: 'ob__search__input' },
                                '#order-builder-search',
                            ) ||
                            searchParentElements(
                                event.target,
                                { type: 'class', value: 'ob__searchcard' },
                                '#order-builder-search',
                            )
                        )
                    ) {
                        this.showDropDown = false;
                    }
                },
                availability: function (part) {
                    let html = ``;
                    console.log('Availability', part.Product.Availability);
                    switch (part.Product.Availability) {
                        case 100:
                            html =
                                '<i class="ob__overview__icon success fa fa-check" aria-hidden="true"></i>';
                            break;
                        case 300:
                            html = `<i aria-hidden="true" class="ob__overview__icon alert fa fa-exclamation-triangle"></i>`;
                            break;
                        case 200:
                            html = `<img class="ob__overview__icon" src="/assets/smartship.png">`;
                            break;
                        default:
                    }
                    console.log('html', html);
                    return html;
                },
                updateQuantity: function (part, e) {
                    const qty = e.target.value;
                    part.Quantity = qty;
                    store.dispatch('OrderUpdate', part);
                },

                hover: function (element, bool) {
                    element.hovered = bool;
                },
                partSelected: function (part, needsFocus = true) {
                    part.Quantity = null;
                    const payload = {
                        Term: `${part.Product.ManufacturerCode}, ${part.Product.PartNumber}`,
                        Part: part,
                        DropDown: false,
                        Selected: true,
                    };

                    store.commit('UpdateSearch', payload);
                    if (this.checked) {
                        store.dispatch('UpdateCrossReference');
                        this.search = '';
                    } else {
                        if (needsFocus) {
                            document.querySelector('#qty').focus();
                        }
                    }
                    this.search = payload.Term;
                    this.selectedIndex = -1;
                },
                selectPart: function (e) {
                    if (this.showDropDown != false) {
                        switch (e.keyCode) {
                            case 40:
                                this.selectedIndex =
                                    this.selectedIndex >= this.searchResults.length - 1
                                        ? 0
                                        : this.selectedIndex + 1;
                                break;
                            case 38:
                                this.selectedIndex =
                                    this.selectedIndex < 1
                                        ? this.searchResults.length - 1
                                        : this.selectedIndex - 1;
                                break;
                            case 9:
                            case 13:
                                const index = Math.max(this.selectedIndex, 0);
                                this.partSelected(this.searchResults[index], e.keyCode === 13);
                                break;
                        }
                    }
                },
                handleQtyClick: function () {
                    if (!Object.keys(this.part).length) {
                        if (this.searchResults.length) {
                            this.partSelected(this.searchResults[0]);
                        }
                    }
                    if (!this.search.length) {
                        this.NoSelectedPart = true;
                    }
                },
                hideModal: function () {
                    store.commit('ToggleModal');
                },
                updatePart: function (part) {
                    store.dispatch('OrderUpdate', part);
                    //store.dispatch('UpdateItemsCount');
                },
                addPart: function (part, enter = true) {
                    if (Object.keys(part).length == 0) {
                        //swal('Required', 'Please enter part #', 'info');
                        return;
                    }
                    if (this.totalItemCount >= this.maxCartItems) {
                        swal(
                            'Maximum order row limit reached',
                            'Orders must have ' + this.maxCartItems + ' rows or less.',
                            'error',
                        );
                        return;
                    }
                    store.dispatch('OrderAdd', part);
                    //store.dispatch('UpdateItemsCount');
                    this.search = '';
                    if (enter === true) {
                        this.$refs.ob_search.focus();
                    } else {
                        this.$refs.ob_switch.focus();
                    }
                },
                addAlternateWarehousePart: function (part, locationId, quantity, stockInfo) {
                    if (this.totalItemCount >= this.maxCartItems) {
                        swal(
                            'Maximum order row limit reached',
                            'Orders must have ' + this.maxCartItems + ' rows or less.',
                            'error',
                        );
                        return;
                    }

                    if (!quantity || quantity <= 0) {
                        Vue.set(stockInfo, 'isQuantityValid', false); // Update validation state
                        return;
                    } else {
                        // Vue.set(stockInfo, 'isQuantityValid', true); //if user would like to reset just the one field.
                        this.selectedPartForPopup.Product.AllStockInfo.forEach((stockInfo) => {
                            Vue.set(stockInfo, 'isQuantityValid', true); // reset everything
                        });
                    }

                    var isOverQuantity = false;

                    // Update the AVAILABLE_COUNT for the specified location
                    if (
                        this.selectedPartForPopup &&
                        this.selectedPartForPopup.Product &&
                        this.selectedPartForPopup.Product.AllStockInfo
                    ) {
                        this.selectedPartForPopup.Product.AllStockInfo.forEach((stockInfo) => {
                            if (stockInfo.LOCATION_ID === locationId) {
                                if (quantity > stockInfo.AVAILABLE_COUNT) {
                                    swal(
                                        'Exceed Maximum quantity',
                                        `Cannot add more than ${stockInfo.AVAILABLE_COUNT} from this location.`,
                                        'error',
                                    );
                                    isOverQuantity = true;
                                    return;
                                }
                                stockInfo.AVAILABLE_COUNT -= quantity;
                            }
                        });
                    }

                    if (isOverQuantity) {
                        return;
                    }

                    const payload = {
                        part: part,
                        locationId: locationId,
                        quantity: quantity ? quantity : 1,
                        selectedPartForPopup: this.selectedPartForPopup,
                    };

                    Vue.set(stockInfo, 'quantity', '');

                    store.dispatch('AlternateWarehouseOrderAdd', payload);
                },
                addAlternativePart: function (part, locationId, quantity, stockInfo) {
                    if (this.totalItemCount >= this.maxCartItems) {
                        swal(
                            'Maximum order row limit reached',
                            'Orders must have ' + this.maxCartItems + ' rows or less.',
                            'error',
                        );
                        return;
                    }

                    if (!quantity || quantity <= 0) {
                        Vue.set(stockInfo, 'isAltQuantityValid', false); // Update validation state
                        return;
                    } else {
                        this.alternativePart.Product.AllStockInfo.forEach((stockInfo) => {
                            Vue.set(stockInfo, 'isAltQuantityValid', true); // reset everything
                        });
                    }

                    var isOverQuantity = false;

                    // Update the AVAILABLE_COUNT for the specified location
                    if (
                        this.alternativePart &&
                        this.alternativePart.Product &&
                        this.alternativePart.Product.AllStockInfo
                    ) {
                        this.alternativePart.Product.AllStockInfo.forEach((stockInfo) => {
                            if (stockInfo.LOCATION_ID === locationId) {
                                if (quantity > stockInfo.AVAILABLE_COUNT) {
                                    swal(
                                        'Exceed Maximum quantity',
                                        `Cannot add more than ${stockInfo.AVAILABLE_COUNT} from this location.`,
                                        'error',
                                    );
                                    isOverQuantity = true;
                                    return;
                                }
                                stockInfo.AVAILABLE_COUNT -= quantity;
                            }
                        });
                    }

                    if (isOverQuantity) {
                        return;
                    }

                    if (this.selectedPartForPopup.DefaultWarehouseLocationId == locationId) {
                        locationId = 0;
                    }

                    const payload = {
                        part: part,
                        locationId: locationId,
                        quantity: quantity ? quantity : 1,
                        selectedPartForPopup: this.alternativePart,
                    };

                    Vue.set(stockInfo, 'quantity', '');

                    store.dispatch('AlternativePartOrderAdd', payload);
                },
                addToCart: function (part) {
                    store.dispatch('OrderAddToCart', part);
                    //store.dispatch('UpdateItemsCount');
                },
                addAllToCart: function () {
                    store.dispatch('OrderAddAllToCart');
                    //store.dispatch('UpdateItemsCount');
                },
                removePart: function (part) {
                    store.dispatch('OrderRemove', part);
                    //store.dispatch('UpdateItemsCount');
                },
                removeAllParts: function () {
                    store.dispatch('OrderRemoveAll');
                    //store.dispatch('UpdateItemsCount');
                },
                showNoteEditor: function (part) {
                    this.currentEditId = part.Product.CartItemId;
                    this.previousNote = part.Product.PartNote;
                },
                saveNote: function (part) {
                    this.updatePart(part);
                    this.currentEditId = null;
                    this.previousNote = null;
                },
                closeNoteEditor: function (part) {
                    part.Product.PartNote = this.previousNote;
                    this.previousNote = null;
                    this.currentEditId = null;
                },
                AltPartSearch: function (part) {
                    this.search = part.m_Item1;
                    //store.dispatch('Autocomplete', { Term: part.m_Item1 })
                },
                alternateWarehouseInventoryPopUp(part) {
                    this.selectedPartForPopup = part;
                    this.selectedPartForPopup.Product.AllStockInfo.forEach((stockInfo) => {
                        Vue.set(stockInfo, 'isQuantityValid', true); // Initialize the validation state
                    });

                    var alternativePartId = this.selectedPartForPopup.Product.AlternativePartId;
                    var altPart = this.alternativeParts.find(
                        (x) => x.Product.Id === alternativePartId,
                    );
                    this.alternativePart = altPart;

                    this.isPopupVisible = true;
                },
                closePopup() {
                    this.isPopupVisible = false;
                    if (
                        this.selectedPartForPopup &&
                        this.selectedPartForPopup.Product.AllStockInfo
                    ) {
                        this.selectedPartForPopup.Product.AllStockInfo.forEach((stockInfo) => {
                            // Reset the quantity for each stockInfo
                            stockInfo.quantity = '';
                        });
                    }
                    this.selectedPartForPopup = null;
                    this.alternativePart = null;
                    this.isCollapsed = true;
                },
                toggleCollapse() {
                    this.isCollapsed = !this.isCollapsed;
                },
                hasAlternativePartAvailable(part) {
                    if (part.AlternativePartId) {
                        const alternativePart = this.alternativeParts.find(
                            (altPart) => altPart.Product.Id === part.AlternativePartId,
                        );

                        if (alternativePart) {
                            const totalAvailableCount = alternativePart.Product.AllStockInfo.reduce(
                                (acc, item) => acc + item.AVAILABLE_COUNT,
                                0,
                            );
                            return totalAvailableCount > 0;
                        }
                    }
                    return false;
                },
            },
        });
    }
});



// WEBPACK FOOTER //
// ./app/js/modules/vue/vues/order-builder/order-builder-search.js